(function () {
  'use strict';

  function initToggle(el) {
    var radios = el.querySelectorAll('[data-fc-price-radio]');
    var details = el.querySelector('[data-fc-insider-details]');
    var submitBtn = el.querySelector('[data-fc-insider-submit]');
    var submitText = el.querySelector('[data-fc-submit-text]');
    var errorEl = el.querySelector('[data-fc-insider-error]');

    var regularPrice = parseInt(el.dataset.regularPrice, 10);
    var memberPrice = parseInt(el.dataset.memberPrice, 10);
    var productVariantId = el.dataset.variantId;
    var insiderVariantId = el.dataset.insiderVariantId;
    var insiderSellingPlan = el.dataset.insiderSellingPlan;

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        try {
          return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
        } catch (e) {
          /* fall through to plain formatting below */
        }
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function selectedOption() {
      var checked = el.querySelector('[data-fc-price-radio]:checked');
      return checked ? checked.value : 'regular';
    }

    function updateUI() {
      var isMember = selectedOption() === 'member';
      if (details) {
        details.hidden = !isMember;
      }
      if (submitText) {
        var price = isMember ? memberPrice : regularPrice;
        submitText.textContent = 'Add to bag \u2014 ' + formatMoney(price);
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', updateUI);
    });

    updateUI();

    if (!submitBtn) {
      return;
    }

    function cartAlreadyHasMembership() {
      return fetch('/cart.js')
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Cart fetch failed with status ' + response.status);
          }
          return response.json();
        })
        .then(function (cart) {
          return cart.items.some(function (item) {
            return String(item.variant_id) === String(insiderVariantId);
          });
        });
    }

    submitBtn.addEventListener('click', function () {
      if (submitBtn.disabled) {
        return;
      }

      var isMember = selectedOption() === 'member';

      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
      if (errorEl) {
        errorEl.hidden = true;
      }

      var membershipCheck = isMember ? cartAlreadyHasMembership() : Promise.resolve(false);

      membershipCheck
        .then(function (alreadyHasMembership) {
          var items = [{ id: productVariantId, quantity: 1 }];

          if (isMember && !alreadyHasMembership) {
            items.push({
              id: insiderVariantId,
              quantity: 1,
              selling_plan: insiderSellingPlan
            });
          }

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Cart add failed with status ' + response.status);
          }
          return response.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          console.error('fc-insider-toggle: add to cart failed', err);
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
          if (errorEl) {
            errorEl.hidden = false;
          }
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-fc-insider-toggle]').forEach(function (el) {
      if (el.dataset.fcInsiderToggleInitialized) {
        return;
      }
      el.dataset.fcInsiderToggleInitialized = 'true';
      initToggle(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
